import Modal from 'react-modal'
import './login-modal.css';
import agent from '../agent';
import React from 'react';
import SignUpModal from './signUpModal.js'
import LoginFeedbackModal from './LoginFeedbackModal.js'
import { BACKEND_URL } from '../constants/constants';
import EmailVerificationModal from './EmailVerificationModal.js';
import SGIDSelectionModal from './SGIDSelectionModal.js'

class LoginModal extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showLoginPrompt: false,
      showPassword: false,
      username: '',
      password: '',
      showError: false,
      handle: ''
    }
    this.openLoginPrompt = this.openLoginPrompt.bind(this);
    this.closeLoginPrompt = this.closeLoginPrompt.bind(this);
    this.getPasswordType = this.getPasswordType.bind(this);
    this.hidePassword = this.hidePassword.bind(this);
    this.showPassword = this.showPassword.bind(this);
    this.handleUsernameChange = this.handleUsernameChange.bind(this);
    this.handlePasswordChange = this.handlePasswordChange.bind(this);
    this.submitCredentials = this.submitCredentials.bind(this);
    this.openSignUpModal = this.openSignUpModal.bind(this);
    this.forgotPassword = this.forgotPassword.bind(this);
  }

  openLoginPrompt (handle) {
    this.setState({ handle });
    this.setState({ showLoginPrompt: true });
  }
  
  closeLoginPrompt () {
    this.setState({ showLoginPrompt: false });
  }

  getPasswordType () {
    if (this.state.showPassword) {
      return "text"
    } else {
      return "password"
    }
  }

  hidePassword () {
    this.setState({ showPassword: false });
    this.forceUpdate() 
  }

  showPassword () {
    this.setState({ showPassword: true });
    this.forceUpdate() 
  }

  handleUsernameChange (e) {
    this.setState({ username: e.target.value });
  }

  handlePasswordChange (e) {
    this.setState({ password: e.target.value });
  }

  submitCredentials () {
    agent.Profile.login(this.state.username, this.state.password).then((user) => {
      this.closeLoginPrompt()
      if (user.verified && user.openid && user.preferredName) {
        this.refs.loginFeedbackModal.openLoginFeedback(user.preferredName)
      } else if (user.verified && user.openid && !user.preferredName) {

      } else if (user.verified && !user.openid && !user.preferredName) {
        this.refs.EmailVerificationModal.refs.SGIDPromptModal.openLoginPrompt(this.state.handle)
      } else if (!user.verified && !user.openid && !user.preferredName) {
        this.refs.EmailVerificationModal.openLoginPrompt(user.email, this.state.handle)
      }
      this.setState({ showError: false });
      this.forceUpdate() 
    })
    .catch(error => {
      this.setState({ showError: true });
    })
  }

  forgotPassword (event) {
    event.preventDefault()
    this.refs.signUpModal.openLoginPrompt({
      handle: this.state.handle,
      isPasswordReset: true
    })
    this.closeLoginPrompt()
  }

  openSignUpModal (event) {
    event.preventDefault()
    this.refs.signUpModal.openLoginPrompt({
      handle: this.state.handle,
      isPasswordReset: false
    })
    this.closeLoginPrompt()
  }

  render() {
    return (
      <div>
        <Modal
          isOpen={this.state.showLoginPrompt}
          onRequestClose={this.closeLoginPrompt}
          className="login-modal"
          overlayClassName="Overlay">
          <img src={`${BACKEND_URL}/assets/logo-grey.png`}></img>
          <div className="title">Log in</div>
          <input className="username" placeholder="Email address" autoFocus onChange={this.handleUsernameChange}></input>
          <div className="password-container">
            <i className="bx bx-show" onClick={this.hidePassword} style={this.state.showPassword ? { visibility: "visible" } : { visibility: "hidden" }}></i>
            <i className="bx bx-hide" onClick={this.showPassword} style={this.state.showPassword ? { visibility: "hidden" } : { visibility: "visible" }}></i>
            <input className="password" type={this.state.showPassword ? "text" : "password"} placeholder="Password" onChange={this.handlePasswordChange}></input>
          </div>
          <div className="forgot" onClick={this.forgotPassword}>
            Forgot Password?
          </div>
          <div className="error" style={this.state.showError ? { visibility: "visible" } : { visibility: "hidden" }}>Username/password combination is incorrect.</div>
          <div className="submit" onClick={this.submitCredentials}>
            Submit
          </div>
          <div className="cancel-container">
            <div className="cancel-prompt">Not a member?</div>
            <a className="cancel-btn" onClick={ this.openSignUpModal }>Sign up here</a>
          </div>
        </Modal>
        <SignUpModal container={this} ref="signUpModal"/>
        <LoginFeedbackModal container={this} ref="loginFeedbackModal"/>
        <EmailVerificationModal container={this} ref="EmailVerificationModal"/>
        {/* <SGIDSelectionModal container={this} ref="SGIDSelectionModal" currentUser={this.props.currentUser}/> */}
      </div>
    ); 
  }
}

export default LoginModal


// WEBPACK FOOTER //
// ./src/components/LoginModal.js